import { refreshSessionToken } from "src/state/actionCreators/refreshSessionToken";
import { AppDispatch } from "state/types";

const createSessionTokenRefreshHandler =
  ({ dispatch }: { dispatch: AppDispatch }) =>
  () =>
    dispatch(refreshSessionToken());

export default createSessionTokenRefreshHandler;
